import clsx from 'clsx'
import React, { FC } from 'react'

import SvgCheck from '@Assets/SVG/Check'
import { ImageV4 } from '@Components/Image'
import { Maybe } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './LineItemPersonalization.module.scss'

export interface LineItemPersonalizationProps {
  action?: React.ReactNode
  discountPrice?: string | Maybe<string>
  imageUrl?: string
  isFree?: boolean
  isPowerStep?: boolean
  onAdd?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onEdit?: () => void
  onRemove?: () => void
  originalPrice?: string | Maybe<string>
  showAsLineItem?: boolean
  showCheckBox?: boolean
  text?: string
  title?: string
}

export const LineItemPersonalization: FC<LineItemPersonalizationProps> = ({
  action,
  discountPrice,
  imageUrl,
  isFree,
  isPowerStep = false,
  onAdd,
  onEdit,
  onRemove,
  originalPrice,
  showAsLineItem = false,
  showCheckBox,
  text,
  title,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        styles.lineItemPersonalization,
        showAsLineItem && styles.showAsLineItem,
        onAdd && styles.addable,
        isPowerStep && styles.powerStep,
      )}
      onClick={(e) => {
        if (onAdd) {
          onAdd(e)
        }
      }}
    >
      {imageUrl && (
        <div className={styles.imageWrapper}>
          <ImageV4 height={showAsLineItem ? 90 : 70} src={imageUrl} width={showAsLineItem ? 90 : 70} />
        </div>
      )}
      <div className={clsx(styles.contentWrapper, onAdd && styles.toBasket, (onRemove || text) && styles.inBasket)}>
        <div className={styles.content}>
          {title}
          {text && (
            <div className={styles.text}>
              {text}
              {onEdit && (
                <>
                  {' - '}
                  <button className={styles.edit} onClick={onEdit} type="button">
                    {t('cart:CHANGE')}
                  </button>
                </>
              )}
            </div>
          )}
        </div>
        <div className={styles.actions}>
          {originalPrice && (
            <span className={styles.prices}>
              {!isFree && discountPrice && <p className={styles.discount}>{`+ ${discountPrice}`}</p>}
              {isFree && <span className={styles.discount}>{t('header:FREE_LABEL')}</span>}
              {originalPrice && (() => {
                let prefix = ''
                if (!discountPrice) {
                  prefix = onAdd ? '+' : ''
                }
                return (
                  <span className={clsx(styles.price, (isFree || discountPrice) && styles.discounted)}>{`${prefix} ${originalPrice}`}</span>
                )
              })()}
            </span>
          )}

          {action}

          {!action && showCheckBox && <div className={clsx(styles.add, showCheckBox && styles.success)}><SvgCheck /></div>}
        </div>
      </div>
    </div>
  )
}

